import { AppleOutlined } from '@ant-design/icons';
import { Breadcrumb, Card, Layout, Tabs, TabsProps, theme } from 'antd';
import { Content } from 'antd/es/layout/layout';
import React from 'react';
import Web from './components/web';


const MetaTitleCounter: React.FC = () => {

    const { token: { colorBgContainer }, } = theme.useToken();

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: <span> <AppleOutlined />WEB</span>,
            children: <Web />,
        },
        // {
        //     key: '2',
        //     label: <span> <AndroidOutlined />PLAY</span>,
        //     children: <Play />,
        // },
    ];

    return (
        <Layout>
            <Content className="site-layout" style={{ padding: '0 50px' }}>
                <Breadcrumb style={{ margin: '16px 0' }}>
                </Breadcrumb>
                <Card title="Title Tag and Meta Description Length Tools" bordered={false} style={{ width: 'auto' }}>
                    <Tabs
                        defaultActiveKey="1"
                        items={items}
                        indicatorSize={(origin) => origin - 16}
                    />
                </Card>
            </Content>
            {/* <Footer style={{ textAlign: 'center' }}>Ant Design ©2023 Created by Ant UED</Footer> */}
        </Layout>
    );
};

export default MetaTitleCounter;